import React from 'react';
import NeoInput from '../neoInput';
import { RadioButton } from './radioGroup';
import Style from '../../style/components/detailsInput.module.css'

export default function DetailsInput({ inputs, label, label_no, label_yes, default_value, className, type, onChange, ...rest }) {

    // TODO : Use setFormValue props to fake key of childs
    const [displayDetails, setDisplayDetails] = React.useState(default_value);

    const change = React.useCallback((value)=>{
        if(!value){
            onChange(null);
        }
        setDisplayDetails(value);
    }, [onChange, setDisplayDetails])

    return(
        <div className={Style["details-container"]}>
            <div className={`${Style["details-radio-button-container"]} ${className} input-group radio-button`}>
                <RadioButton type={"radio"} value={true} label={label_yes} onChange={change} key={"details_yes"} currentValue={displayDetails} className={`${Style["details-radio-button"]} radio-button ${displayDetails ? 'active' : 'inactive'}`} />
                <RadioButton type={"radio"} value={false} label={label_no} onChange={change} key={"details_no"} currentValue={displayDetails} className={`${Style["details-radio-button"]} radio-button ${!displayDetails ? 'active' : 'inactive'}`} />
            </div>
            {displayDetails && <div className={Style["details-input-container"]}><NeoInput onChange={onChange} {...inputs[0]} {...rest}  /></div> }
        </div>

    )
}
